<template>
  <div class="search">
    <div class="filters-wrapper" :class="[showDescredenciadosDialog ? 'warning' : '']" @click="handleWarning">
      <h3 class="func-62-title-header">
        Busca de descredenciados
      </h3>
      <el-form label-position="top">
        <el-form-item label="Estado" :required="true">
          <el-select
            class="form-select"
            v-model="estado"
            placeholder="Selecione"
            :disabled="!options.estados"
            filterable
            clearable>
            <el-option
              v-for="(item, index) in options.estados"
              :key="index"
              :value="item.id_estado"
              :label="item.descricao"
              class="extended-option"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Plano" :required="true">
          <el-select
            class="form-select"
            v-model="idPlano"
            placeholder="Selecione"
            :disabled="!options.planos"
            filterable
            clearable>
            <el-option
              v-for="(item, index) in options.planos"
              :key="index"
              :value="item.id_plano"
              :label="item.descricao"
              class="extended-option"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Tipo de prestador" :required="true">
          <el-select
            class="form-select"
            v-model="idTipoPrestador"
            placeholder="Selecione"
            :disabled="!options.tiposPrestadores"
            filterable
            clearable>
            <el-option
              v-for="(item, index) in options.tiposPrestadores"
              :key="index"
              :value="item.id_tipo_prestador"
              :label="item.tipo_prestador"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Especialidade" :required="true">
          <el-select
            class="form-select"
            v-model="idEspecialidade"
            placeholder="Selecione"
            :disabled="!options.especialidades"
            filterable
            clearable>
            <el-option
              v-for="(item, index) in options.especialidades"
              :key="index"
              :value="item.id_especialidade"
              :label="item.especialidade"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Nome do prestador">
          <el-input v-model="nomePrestador" clearable :disabled="!canSubmit" style="width: 100%" />
        </el-form-item>
        <el-button
          @click="listarDescredenciados"
          :style="{
            background: estilo.aplicacao.corPrimariaAplicacao,
            color: 'white',
            opacity: canSubmit ? 1 : 0.5
          }"
          class="func-62-btn-pesquisar"
          :disabled="!canSubmit"
          :loading="loadingDescredenciados"
        >
          PESQUISAR
        </el-button>
      </el-form>
    </div>
    <el-card v-if="showDescredenciadosDialog" class="box-card">
      <h2>Atenção</h2>
      <p>
        Não há descredenciados para pesquisar no momento.
      </p>
      <el-button
        type="primary"
        size="medium"
        class="btn"
        :style="{
          background: estilo.aplicacao.corPrimariaAplicacao,
          color: 'white',
          opacity: canSubmit ? 1 : 0.5
        }"
        @click="() => showDescredenciadosDialog = false"
      >
        OK
      </el-button>
    </el-card>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'BuscaRedeDescredenciada',
  data: () => ({
    estado: '',
    idPlano: '',
    idTipoPrestador: '',
    idEspecialidade: '',
    nomePrestador: '',
    descredenciados: null,
    options: {
      estados: null,
      planos: null,
      tiposPrestadores: null,
      especialidades: null
    },
    loadingDescredenciados: false,
    semDescredenciados: false,
    showDescredenciadosDialog: false
  }),
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade']),
    ...mapGetters('SetupApp', ['estilo', 'aplicacao']),
    canSubmit () {
      return this.estado && this.idPlano && this.idTipoPrestador && this.idEspecialidade
    }
  },
  watch: {
    estado (estado) {
      this.listarPlanos(estado)
      this.options.tiposPrestadores = null
      this.options.especialidades = null
      this.idPlano = null
      this.idTipoPrestador = null
      this.idEspecialidade = null
    },
    idPlano (idPlano) {
      if (!['', null].includes(idPlano)) this.listarTiposPrestadores(this.estado, idPlano)
      this.options.tiposPrestadores = null
      this.options.especialidades = null
      this.idTipoPrestador = null
      this.idEspecialidade = null
    },
    idTipoPrestador (idTipoPrestador) {
      if (!['', null].includes(idTipoPrestador)) this.listarEspecialidades(this.estado, this.idPlano, idTipoPrestador)
      this.options.especialidades = null
      this.idEspecialidade = null
    }
  },
  created () {
    this.listarEstados()
  },
  methods: {
    emptyList () {
      this.showDescredenciadosDialog = true
      this.semDescredenciados = true
      this.$emit('emptyList')
    },
    async listarEstados () {
      const result = await this.apiFuncionalidade.listaEstados({
        payload: { idOperadora: this.aplicacao.idOperadora },
        handlerErrorIgnore: true
      })
      if (!result || !result.status) {
        this.emptyList()
        return this.showEmpty()
      }

      this.options.estados = result.data
    },
    async listarPlanos (estado) {
      const result = await this.apiFuncionalidade.listaPlanos({
        payload: { idOperadora: this.aplicacao.idOperadora, estado },
        handlerErrorIgnore: true
      })
      if (!result || !result.status) return this.showEmpty()
      this.options.planos = result.data
    },
    async listarTiposPrestadores (estado, idPlano) {
      const result = await this.apiFuncionalidade.listaTiposPrestadores({
        payload: { idOperadora: this.aplicacao.idOperadora, estado, idPlano },
        handlerErrorIgnore: true
      })
      if (!result || !result.status) return this.showEmpty()
      this.options.tiposPrestadores = result.data
    },
    async listarEspecialidades (estado, idPlano, idTipoPrestador) {
      const result = await this.apiFuncionalidade.listaEspecialidades({
        payload: { idOperadora: this.aplicacao.idOperadora, estado, idPlano, idTipoPrestador },
        handlerErrorIgnore: true
      })
      if (!result || !result.status) return this.showEmpty()
      this.options.especialidades = result.data
    },
    async listarDescredenciados () {
      const payload = {
        idOperadora: this.aplicacao.idOperadora,
        estado: this.estado,
        idPlano: this.idPlano,
        idTipoPrestador: this.idTipoPrestador,
        idEspecialidade: this.idEspecialidade
      }

      if (this.nomePrestador) {
        payload.nomePrestador = this.nomePrestador
      }

      this.loadingDescredenciados = true
      const result = await this.apiFuncionalidade.listaDescredenciados({ payload, handlerErrorIgnore: true })
      if (result && result.status) {
        this.loadingDescredenciados = false
        this.setDescredenciadosciados(result.data)
      } else {
        this.setDescredenciadosciados({
          lista: [],
          quantidade: 0
        })
      }
    },
    setDescredenciadosciados (descredenciados) {
      this.descredenciados = descredenciados
      this.$emit('descredenciados', descredenciados)
    },
    showEmpty () {
      this.setDescredenciadosciados(null)
    },
    handleWarning () {
      if (this.semDescredenciados) {
        this.showDescredenciadosDialog = true
      }
    }
  }
}
</script>

<style scoped>
.search {
  position: relative;
}

.filters-wrapper {
  padding-right: 10px;
  padding-left: 10px;
}

.filters-wrapper.warning {
  opacity: 0.7;
}

.func-62-title-header {
  letter-spacing: 0px;
  font-weight: 600;
  color: #333333;
  font-size: 24px;
  margin: 20px 0px 0px;
}

.form-select {
  width: 100%;
}

.box-card {
  position: absolute;
  top: 50%;
  margin: 15px;
  margin-top: -78px;
}

.box-card h2 {
  font-size: 1.4em;
  margin-bottom: 5px;
}

.box-card .btn {
  width: 100%;
  border-radius: 5px;
  padding: 15px 0;
}
</style>
